<template>
  <div class="latterDetail">
    <div class="latterDetail_header">
      <HeadingLv3 class="latterDetail_ttl" :text="data.program" />

      <div class="latterDetail_back">
        <button type="button" @click="showLatterList">
          他の研修プログラム
        </button>
      </div>

      <div v-if="images.length" class="latterDetail_slider">
        <imgSlider :images="images" />
      </div>
    </div>

    <section
      id="about"
      class="hospitalsDetailSection"
      v-if="about.some((row) => row.td)"
    >
      <div class="hospitalsDetailSection_ttl">
        <HeadingLv2 text="プログラムの概要" />
      </div>
      <div class="hospitalsDetailSection_cnt">
        <div class="hospitalsDetailSection_block tableDefinition-mt">
          <TableDefinition :items="aboutTableData" />
        </div>
        <div class="hospitalsDetailSection_block">
          <TableSimple :rows="about" />
        </div>
        <div class="hospitalsDetailSection_block hiddenPc">
          <HospitalContactBtn
            type="latter"
            :id="hospitalId"
            :sTrainingId="data.s_training_id"
            :sTrainingName="data.program"
            :paid-flg="paidFlg"
          />
        </div>
      </div>
    </section>

    <section
      id="special"
      class="hospitalsDetailSection"
      v-if="special.some((row) => row.td)"
    >
      <div class="hospitalsDetailSection_ttl">
        <HeadingLv2 text="専門研修・サブスペシャルティ" />
      </div>
      <div class="hospitalsDetailSection_cnt">
        <div class="hospitalsDetailSection_block">
          <TableSimple :rows="special" />
        </div>
      </div>
    </section>

    <section
      id="feature"
      class="hospitalsDetailSection"
      v-if="data.overview_detail"
    >
      <div class="hospitalsDetailSection_ttl">
        <HeadingLv2 text="研修プログラムの特徴" />
      </div>
      <div class="hospitalsDetailSection_cnt">
        <HospitalTag
          v-if="data.feature_tag.length"
          lg
          style="margin-top: 10px"
          :tags="
            data.feature_tag.map((label) => {
              return { label, disabled: false }
            })
          "
        />
        <ExpandedText :text="data.overview_detail" style="margin-top: 16px" />
        <div class="hospitalsDetailSection_block">
          <HeadingLv3 text="研修の週間計画" />

          <div id="js-latterDetail_schedule" class="latterDetail_schedule">
            <div class="latterDetail_schedule_table">
              <div class="latterDetail_schedule_row">
                <div class="latterDetail_schedule_cell -head"></div>
                <div class="latterDetail_schedule_cell -head -gray">朝</div>
                <div class="latterDetail_schedule_cell -head -gray">午前</div>
                <div class="latterDetail_schedule_cell -head -gray">午後</div>
                <div class="latterDetail_schedule_cell -head -gray">夕方</div>
              </div>
              <div
                class="latterDetail_schedule_row"
                v-for="(row, i) in schedule"
                :key="i"
              >
                <template v-for="(cell, j) in row" :key="cell">
                  <div v-if="j === 0" class="latterDetail_schedule_cell -gray">
                    <span>{{ cell }}</span>
                  </div>
                  <div v-else class="latterDetail_schedule_cell">
                    <span>{{ cell }}</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      id="message"
      class="hospitalsDetailSection"
      v-if="data.s_message || data.greeting_message"
    >
      <div class="hospitalsDetailSection_ttl">
        <HeadingLv2 text="研修医の方へメッセージ" />
      </div>
      <div class="hospitalsDetailSection_cnt">
        <div style="margin-top: 8px">
          <MediaMessage
            v-if="data.s_message"
            :person="data.s_message_person"
            :message="data.s_message"
          />
          <MediaMessage
            v-if="data.greeting_message"
            :person="data.greeting_message_person"
            :message="data.greeting_message"
          />
        </div>
      </div>
    </section>

    <section
      id="environment"
      class="hospitalsDetailSection"
      v-if="environment.some((row) => row.td)"
    >
      <div class="hospitalsDetailSection_ttl">
        <HeadingLv2 text="研修環境" />
      </div>
      <div class="hospitalsDetailSection_cnt">
        <div class="hospitalsDetailSection_block">
          <TableSimple :rows="environment" />
        </div>
      </div>
    </section>

    <section
      id="condition"
      class="hospitalsDetailSection"
      v-if="condition.some((row) => row.td)"
    >
      <div class="hospitalsDetailSection_ttl">
        <HeadingLv2 text="給与・待遇について" />
      </div>
      <div class="hospitalsDetailSection_cnt">
        <div class="hospitalsDetailSection_block">
          <TableSimple :rows="condition" />
        </div>
      </div>
    </section>

    <section
      id="recruitment"
      class="hospitalsDetailSection"
      v-if="visit.some((row) => row.td) || recruitment.some((row) => row.td)"
    >
      <div class="hospitalsDetailSection_ttl">
        <HeadingLv2 text="病院見学・採用試験について" />
      </div>
      <div class="hospitalsDetailSection_cnt">
        <section
          class="hospitalsDetailSection_block"
          v-if="visit.some((row) => row.td)"
        >
          <HeadingLv3
            class="hospitalsDetailSection_blockTtl"
            text="試験・採用"
          />
          <TableSimple :rows="visit" />
        </section>
        <section
          class="hospitalsDetailSection_block"
          v-if="recruitment.some((row) => row.td)"
        >
          <HeadingLv3
            class="hospitalsDetailSection_blockTtl"
            text="試験・採用"
          />
          <TableSimple :rows="recruitment" />
        </section>
        <div class="hospitalsDetailSection_block hiddenPc">
          <HospitalContactBtn
            type="latter"
            :id="hospitalId"
            :sTrainingId="data.s_training_id"
            :sTrainingName="data.program"
            :paid-flg="paidFlg"
          />
        </div>
      </div>
    </section>

    <section class="latterList">
      <h3 class="latterList_ttl">{{ hospitalName }}のプログラム</h3>
      <LatterList :list="list" :showLatterDetail="showLatterDetail" />
    </section>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  computed,
  onMounted,
  onUpdated,
  PropType
} from '@vue/runtime-core'
import TableSimple from '@/components/elements/TableSimple.vue'
import TableDefinition, {
  Definition
} from '@/components/elements/TableDefinition.vue' // eslint-disable-line
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import imgSlider from '@/components/elements/imgSlider.vue'
import HospitalTag from '@/components/elements/HospitalTag.vue'
import ExpandedText from '@/components/elements/ExpandedText.vue'
import MediaMessage from '@/components/block/MediaMessage.vue'
import LatterList from '@/components/block/LatterList.vue'
import HospitalContactBtn from '@/components/block/HospitalContactBtn.vue'
import { Specialist } from '@/types/HospitalDetail'
import { numberFormatAddComma } from '@/utils/commonMethods'
import ScrollHint from 'scroll-hint'
import '../../../node_modules/scroll-hint/css/scroll-hint.css'

export default defineComponent({
  components: {
    TableSimple,
    TableDefinition,
    HeadingLv2,
    HeadingLv3,
    imgSlider,
    HospitalTag,
    ExpandedText,
    MediaMessage,
    LatterList,
    HospitalContactBtn
  },

  props: {
    hospitalName: {
      type: String,
      required: true
    },
    hospitalId: {
      type: Number,
      required: true
    },
    paidFlg: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object as PropType<Specialist>,
      default: () => ({})
    },
    list: {
      type: Object as PropType<Specialist[]>,
      default: () => ({})
    },
    showLatterList: {
      type: Function as PropType<() => void>,
      required: true
    },
    showLatterDetail: {
      type: Function as PropType<(s_training_id: number) => void>,
      required: true
    }
  },

  setup(props, { emit }) {
    const images = computed(() => {
      const res = []
      if (props.data.specialist_image1) {
        res.push({
          src: props.data.specialist_image1,
          alt: ''
        })
      }
      if (props.data.specialist_image2) {
        res.push({
          src: props.data.specialist_image2,
          alt: ''
        })
      }
      if (props.data.specialist_image3) {
        res.push({
          src: props.data.specialist_image3,
          alt: ''
        })
      }
      return res
    })

    const aboutTableData = computed((): Definition[] => {
      return [
        {
          dt: '当科病床数',
          dd:
            props.data.department_bed_num !== null
              ? `${numberFormatAddComma(props.data.department_bed_num)}`
              : 0,
          unit: '床'
        },
        {
          dt: '研修医数',
          dd: props.data.resident_num ?? 0,
          unit: '人'
        },
        {
          dt: '当科指導医数',
          dd: props.data.instructor_num ?? 0,
          unit: '人'
        },
        {
          dt: '募集人数',
          dd: props.data.recruitment_num ?? 0,
          unit: '人'
        }
      ]
    })

    const about = computed(() => {
      return [
        {
          th: props.data.resident_year
            ? `在籍研修医数（${props.data.resident_year}）`
            : '在籍研修医数',
          td: props.data.resident_info ? props.data.resident_info : ''
        },
        {
          th: '給与',
          td: props.data.s_salary || ''
        },
        {
          th: '当直回数',
          td: props.data.s_shifts_info || ''
        }
      ]
    })

    const special = computed(() => {
      return [
        {
          th: '専門研修プログラム科目',
          td: props.data.program_subjects.length
            ? props.data.program_subjects.join('、')
            : ''
        },
        {
          th: '基幹施設／連携施設',
          td:
            props.data.facility && props.data.facility !== 'その他'
              ? props.data.facility
              : ''
        },
        {
          th: '連携施設',
          td: props.data.collaboration_facility || ''
        }
      ]
    })

    const schedule = computed(() => {
      const res: string[][] = []
      const weekEn = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'san']
      const weekJa = ['月', '火', '水', '木', '金', '土', '日']

      weekEn.forEach((day, index) => {
        const arr = []
        arr.push(weekJa[index])
        for (let i = 1; i <= 4; i++) {
          /* @ts-ignore */
          const val = props.data[`training_plan_${day}_${i}`] || ''
          arr.push(val)
        }
        res.push(arr)
      })

      return res
    })

    const environment = computed(() => {
      let responsible = props.data.responsible || ''
      if (responsible && props.data.responsible_university)
        responsible += `（${props.data.responsible_university} 出身）`

      let instructor = ''
      if (props.data.instructor_num) {
        instructor += `${props.data.instructor_num}人`
      }
      if (
        !!props.data.instructor_num &&
        props.data?.instructor_university.length > 0
      ) {
        instructor += `<br>主な出身大学<br>${props.data.instructor_university.join(
          ','
        )}`
      }

      return [
        {
          th: '責任者',
          td: responsible
        },
        {
          th: '当科病床数',
          td: props.data.department_bed_num
            ? `${numberFormatAddComma(props.data.department_bed_num)}床`
            : ''
        },
        {
          th: '当科平均外来患者数',
          td: props.data.s_outpatient_num_avg
            ? `${numberFormatAddComma(props.data.s_outpatient_num_avg)}人`
            : ''
        },
        {
          th: '当科平均入院患者数',
          td: props.data.s_inpatient_num_avg
            ? `${numberFormatAddComma(props.data.s_inpatient_num_avg)}人`
            : ''
        },
        {
          th: props.data.instructor_year
            ? `在籍指導医（${props.data.instructor_year})`
            : '在籍指導医',
          td: instructor
        },
        {
          th: props.data.resident_year
            ? `専攻医・専門研修医（${props.data.resident_year}）`
            : '専攻医・専門研修医',
          td: props.data.resident_info ? props.data.resident_info : ''
        },
        {
          th: 'カンファレンスについて',
          td: props.data.conference_info || ''
        },
        {
          th: '研修修了後の進路',
          td: props.data.course || ''
        }
      ]
    })

    const condition = computed(() => {
      return [
        {
          th: '給与',
          td: props.data.s_salary || ''
        },
        {
          th: '賞与',
          td: props.data.s_bonus || ''
        },
        {
          th: '医師賠償責任保険',
          td: props.data.doctor_liability_insurance || ''
        },
        {
          th: '宿舎・住宅',
          td: props.data.dormitory || ''
        },
        {
          th: '社会保険',
          td: props.data.social_insurance || ''
        },
        {
          th: '福利厚生',
          td: props.data.s_welfare || ''
        },
        {
          th: '学会補助',
          td: props.data.auxiliary || ''
        },
        {
          th: '当直回数',
          td: props.data.s_shifts_info || ''
        },
        {
          th: '当直料',
          td: props.data.on_duty_fee || ''
        }
      ]
    })

    const visit = computed(() => {
      return [
        {
          th: '病院見学実施日',
          td: props.data.hospital_tour_day || ''
        },
        {
          th: '見学交通費補助',
          td: props.data.transportation_subsidy || ''
        },
        {
          th: 'その他',
          td: props.data.hospital_tour_info || ''
        }
      ]
    })

    const recruitment = computed(() => {
      const contact = []
      if (props.data.application_manager)
        contact.push(props.data.application_manager)
      if (props.data.application_tel)
        contact.push(
          `TEL：<a href="tel:${props.data.application_tel}">${props.data.application_tel}</a>`
        )
      if (props.data.application_email)
        contact.push(
          `E-mail：<a href="mail:${props.data.application_email}">${props.data.application_email}</a>`
        )

      return [
        {
          th: '試験日程',
          td: props.data.exam_schedule || ''
        },
        {
          th: '選考方法',
          td: props.data.exam_method || ''
        },
        {
          th: '採用予定人数',
          td: props.data.recruitment_num
            ? `${props.data.recruitment_num}人`
            : ''
        },
        {
          th: '応募書類',
          td: props.data.application_document || ''
        },
        {
          th: '応募締切',
          td: props.data.application_deadline || ''
        },
        {
          th: '応募連絡先',
          td: contact.length ? contact.join('<br>') : ''
        }
      ]
    })

    const getLocalNav = () => {
      const res = []

      if (about.value.some((row) => row.td))
        res.push({ id: 'about', label: 'プログラムの概要' })
      if (special.value.some((row) => row.td))
        res.push({ id: 'special', label: '専門研修・サブスペシャルティ' })
      if (props.data.overview_detail)
        res.push({ id: 'feature', label: '研修プログラムの特徴' })
      if (props.data.s_message || props.data.greeting_message)
        res.push({ id: 'message', label: '研修医の方へメッセージ' })
      if (environment.value.some((row) => row.td))
        res.push({ id: 'environment', label: '研修環境' })
      if (condition.value.some((row) => row.td))
        res.push({ id: 'condition', label: '給与・待遇について' })
      if (
        visit.value.some((row) => row.td) ||
        recruitment.value.some((row) => row.td)
      )
        res.push({ id: 'recruitment', label: '病院見学・採用試験について' })

      return res
    }

    onUpdated(() => emit('update', getLocalNav()))
    onMounted(() => emit('update', getLocalNav()))

    const scrollAnime = onMounted(() => {
      new ScrollHint('#js-latterDetail_schedule', {
        i18n: {
          scrollable: '横スクロールで表示'
        }
      } as any)
    })

    return {
      images,
      aboutTableData,
      about,
      schedule,
      special,
      environment,
      condition,
      visit,
      recruitment,
      scrollAnime
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.latterDetail {
  padding-bottom: 30px;

  @include mixins.media() {
    padding-bottom: 48px;
  }

  &_ttl {
    margin-bottom: 20px;
  }

  &_header {
    margin-bottom: 30px;

    @include mixins.mediaMax() {
      padding-top: 24px;
      padding-left: 16px;
      padding-right: 16px;
    }

    @include mixins.media() {
      margin-bottom: 50px;
    }
  }

  &_slider {
    margin-top: 24px;
  }
}

.latterList {
  @include mixins.mediaMax() {
    padding-left: 16px;
    padding-right: 16px;
  }

  &_ttl {
    font-size: 2.2rem;
    font-weight: 500;
  }
}

.latterDetail_back {
  button {
    display: inline-block;
    height: 40px;
    border-radius: 10px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    padding-left: 16px;
    padding-right: 16px;
    font-weight: 500;

    &:before {
      content: '';
      display: inline-block;
      width: 8px;
      height: 8px;
      border-right: 2px solid var.$color-main;
      border-bottom: 2px solid var.$color-main;
      transform: rotate(135deg);
      margin-right: 4px;
    }
  }
}

.latterDetail_schedule {
  width: calc(100% + 16px);
  margin-top: 16px;
  overflow-x: auto;

  &_table {
    width: 100%;
    min-width: 800px;
    padding-right: 16px;
    padding-bottom: 30px;

    @include mixins.media() {
      min-width: 560px;
      padding-right: 0;
      padding-bottom: 0;
    }
  }

  &_row {
    display: flex;
  }

  &_cell {
    padding: 24px 16px;
    line-height: 1.5;
    flex-basis: 100%;
    border-right: 1px solid var.$color-border-gray;
    border-bottom: 1px solid var.$color-border-gray;

    &:first-child {
      flex-basis: 48px;
      flex-shrink: 0;
      border-left: 1px solid var.$color-border-gray;
      border-right: none;
    }

    &.-head {
      padding-top: 8px;
      padding-bottom: 8px;
      border-top: 1px solid var.$color-border-gray;
      border-bottom: none;
    }
    &.-gray {
      background-color: var.$color-other-bg;
    }

    span {
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
}

.tableDefinition-mt {
  margin-top: 8px;

  @include mixins.media() {
    margin-top: 16px;
  }
}

::v-deep .scroll-hint-icon {
  width: 130px;
  height: 110px;
  padding: 35px 0 10px;
  background-color: rgba(41, 204, 195, 0.9);
}

::v-deep .scroll-hint-text {
  font-size: 11px;
  font-weight: 700;
}
</style>
